export const platform = navigator.userAgent
    .toLowerCase()
    .includes('mac')
    ? 'mac'
    : 'win';
